import React, { Component } from 'react';
import cx from 'classnames'

import './gallery-wave.css'


export class PureWaveGallery extends Component {

  getFullSreenImage(){
    const {selectedRow, selectedCol, cols, photos} = this.props; 
    return photos[selectedRow*cols + selectedCol]
  }

  render(){   
    const {cols, rows, photos, width} = this.props; 

    let demo_parts=[];
    let i=0; 
    for(let row = 0; row < rows; row++) {
      for (let col = 0; col < cols; col++) {
        demo_parts.push(this.renderPhoto(row, col, photos[i]));
        i++;
      }
    }
  
    return (
      <div className="demo__gallery" style={{width:width}} >
           {demo_parts}
      </div>
    )
  }

  renderPhoto = (row, col, photo) => {
    const { 
      cols, rows, colSize, rowSize,
      showBack, selectedRow, selectedCol, 
      onClick 
    } = this.props

    const distance = Math.abs(selectedRow - row) + Math.abs(selectedCol - col)
    const transitionDelay = showBack ? `${10 + distance * 100}ms` : '0ms'
    return (
    <div key={row+'-'+col} 
         className={cx('demo__part', {"show-front": !showBack})}
         style={{ width: colSize, height: rowSize, transitionDelay }}
         onClick={() => onClick(row, col)}>
      <div className="demo__part-back">
          <div className="demo__part-back-inner" 
               style={{ 
                 width: colSize*cols,
                 height: rowSize*rows,
                 backgroundImage:`url(${this.getFullSreenImage().src})`,
                 transform: `translate(${-col*colSize}px, ${-row*rowSize}px)`
              }} />
      </div>
      <div className="demo__part-front" style={{backgroundImage:'url('+photo.src+')'}} />
    </div>)
  }
}

export class WaveGallery extends Component {

  state = {
    showBack: false,
    selectedRow: 0,
    selectedCol: 0,
    fullscreenImage : null
  }

  componentDidMount(){
    this._isMounted = true
    for(let i=0; i<4; i++){
      setTimeout(() => this.handleClick(i, i), ((2000*i)+1000)*2)
      setTimeout(() => this.handleClick(i, i), ((2000*i)+2000)*2)
    }
  }

  componentWillUnmount(){
    this._isMounted = false
  }

  handleClick = (row, col) => {
    if (this.state.showBack){
      this.setState({ showBack: false })
    } else {
      this.setState({
        showBack: true,
        selectedRow: row,
        selectedCol: col,
      });
    }
  }

  getPhotos(){
    const requiredCount = this.props.rows * this.props.cols
    const photos = []
    for(let i=0; i<requiredCount; i++){
      photos.push(this.props.photos[i%this.props.photos.length])
    }
    return photos
  }

  render(){
    const {photos} = this.props; 
    if (photos.length === 0) return null

    return <PureWaveGallery padding={2} 
                            {...this.props} 
                            {...this.state}
                            photos={this.getPhotos()} 
                            onClick={this.handleClick} />
  }
}


// WEBPACK FOOTER //
// ./src/components/Galleries/WaveGallery/index.js